const FALLBACK_CATEGORY = 'uncategorized';

const normalizeCategory = (category: string): string => {
  const normalized = category.trim().toLowerCase().replace(/\s+/g, ' ');
  return normalized || FALLBACK_CATEGORY;
};

const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
};

export function getCategoryColor(category: string): string {
  const normalized = normalizeCategory(category || '');
  const hue = hashString(normalized) % 360;
  return `hsl(${hue}, 62%, 42%)`;
}

